/**
 * Skills Info Command
 * Show detailed information about a locally installed skill
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../services/config.service.js';
import { SkillsService } from '../../services/skills.service.js';

export function createSkillsInfoCommand(): Command {
    return new Command('info')
        .description('Show detailed information about a skill')
        .argument('<name>', 'Skill name')
        .option('--server', 'Show info from Jai1 server instead of local')
        .action(async (name: string, options: { server?: boolean }) => {
            const skillsService = new SkillsService();

            if (options.server) {
                // Show server info
                const configService = new ConfigService();
                const config = await configService.load();

                if (!config) {
                    console.log(chalk.red('❌ Chưa xác thực. Chạy "jai1 auth" trước.'));
                    process.exit(1);
                }

                const filepath = name.startsWith('skills/') ? name : `skills/${name}`;
                const { ComponentsService } = await import('../../services/components.service.js');
                const componentsService = new ComponentsService();

                try {
                    const component = await componentsService.get(config, filepath);

                    console.log(`\n🛠 ${chalk.bold(component.name || name)}\n`);
                    console.log(`Filepath:    ${component.filepath}`);
                    console.log(`Version:     ${component.version}`);
                    console.log(`Downloads:   ${component.downloads}`);
                    if (component.description) {
                        console.log(`Description: ${component.description}`);
                    }
                    if (component.tags && component.tags.length > 0) {
                        console.log(`Tags:        ${component.tags.join(', ')}`);
                    }
                    console.log(`Type:        ${component.contentType}`);
                    console.log();
                    console.log(chalk.dim('💡 Dùng "j skills add ' + name + '" để cài đặt'));
                } catch (error) {
                    console.log(chalk.red(`❌ Không tìm thấy skill "${name}" trên server.`));
                    process.exit(1);
                }
            } else {
                // Show local info
                const projectRoot = process.cwd();
                const skill = await skillsService.getSkillInfo(projectRoot, name);

                if (!skill) {
                    console.log(chalk.red(`❌ Skill "${name}" chưa được cài đặt.`));
                    console.log(chalk.dim('💡 Dùng "j skills info ' + name + ' --server" để xem trên server'));
                    console.log(chalk.dim('   hoặc "j skills add ' + name + '" để cài đặt'));
                    process.exit(1);
                }

                console.log(`\n🛠 ${chalk.bold(skill.name)}\n`);
                console.log(`Slug:        ${skill.slug}`);
                console.log(`Description: ${skill.description || chalk.dim('(none)')}`);
                console.log(`Path:        ${skill.path}`);
                console.log(`Files:       ${skill.fileCount}`);
                console.log();
                console.log(chalk.dim('💡 Dùng "j skills sync" để đồng bộ sang IDE(s)'));
            }
        });
}
